import { match as error } from "../../../src/params/error.ts";

export const matchers = { error };